import ApiService from './api.service';

// Actions
export const GET_WPS_LIST = 'getWpsList';
export const GET_DETAIL_WPS = 'getDetailWps';
export const CREATE_WPS = 'createWps';
export const UPDATE_WPS = 'updateWps';
export const APPROVE_WPS = 'approveWps';
export const REJECT_WPS = 'rejectWps';
export const CANCEL_WPS = 'cancelWps';
export const APPROVE_DISBURSE_WPS = 'approveDisburseWps';
export const REJECT_DISBURSE_WPS = 'rejectDisburseWps';
export const PROCESS_DISBURSE_WPS = 'processDisburseWps';
export const INQUIRY_APPROVAL_WPS = 'inquiryApprovalWps';
export const INQUIRY_APPROVAL_FINANCE = 'inquiryApprovalFinance';
export const SUBMIT_APPROVAL_FINANCE_WPS = 'submitApprovalFinanceWps';
export const SUBMIT_APPROVAL_CRM_WPS = 'submitApprovalCrmWps';
export const SUBMIT_REJECT_CRM_WPS = 'submitRejectCrmWps';
// WPS Detail
export const GET_REQ_BY_ID_WPS = 'getWpsByIsWps';
export const ADD_EMPLOYEE_TO_REQ_WPS = 'addEmployeeToReqWps';
export const UPDATE_REQ_EMPLOYEE_WPS = 'updateReqEmployeeWps';
export const DELETE_REQ_WPS = 'deleteReqWps';
// Invoice
export const WPS_INVOICE_LIST = 'wpsInvoiceList';
export const DETAIL_WPS_INVOICE_PER_ITEM = 'detailWpsInvoicePerItemm';
export const WPS_LOG = 'wpsLog';
export const WPS_INVOICE_LIST_PER_COMPANY = 'wpsInvoicePerCompanyList';

export const SET_WPS_LIST = 'setWpsList';
export const SET_DETAIL_WPS = 'setDetailWps';
export const SET_REQ_BY_ID_WPS = 'setReqByIdWps';
export const SET_WPS_INVOICE = 'setWpsInvoice';
export const SET_DETAIL_WPS_INVOICE_PER_ITEM = 'setDetailWpsInvoicePerItem';
export const SET_WPS_LOG = 'setWpsLog';
export const SET_DETAIL_LIST = 'setDetailList';

// Helpers

const commitList = (context, mutationType, data, transform = (v) => v) => {
  const rows = data.count ? data.rows.map(transform) : [];
  const normalized = { ...data, rows };
  context.commit(mutationType, normalized);
  return normalized;
};

const apiAction = (method, url, payload, { context, mutation, transform } = {}) => new Promise((resolve, reject) => {
  ApiService[method](url, payload)
    .then(({ data }) => {
      const result = mutation ? commitList({ commit: context.commit }, mutation, data.data, transform) : data.data ?? data;
      resolve(result);
    })
    .catch(reject);
});

const resolveApiBase = (apiNamespace = 'wps') => `api/${apiNamespace}/v1`;

const state = {
  wps_list: {},
  detail_wps: {},
  detail_list: {},
  req_by_id_wps: {},
  wps_invoices: {},
  detail_wps_invoices_per_item: {},
  wps_log: {},
  setting: {},
};

// Getters
const getters = {
  wps_list: (s) => s.wps_list,
  detail_wps: (s) => s.detail_wps,
  detail_list: (s) => s.detail_list,
  req_by_id_wps: (s) => s.req_by_id_wps,
  wps_invoices: (s) => s.wps_invoices,
  detail_wps_invoices_per_item: (s) => s.detail_wps_invoices_per_item,
  wps_log: (s) => s.wps_log,
};

// Actions
const actions = {
  [INQUIRY_APPROVAL_WPS](_, { id, api_namespace = 'wps', ...payload }) {
    return ApiService.post(`${resolveApiBase(api_namespace)}/internals/${id}/inquiry`, payload);
  },
  [INQUIRY_APPROVAL_FINANCE](_, { id, api_namespace = 'wps', ...payload }) {
    return ApiService.post(`${resolveApiBase(api_namespace)}/internals/${id}/inquiry`, payload);
  },

  async [GET_WPS_LIST](context, { api_namespace = 'wps', ...param }) {
    const { data } = await ApiService.get(`${resolveApiBase(api_namespace)}/requests`, param);
    const result = data?.data ?? data;

    if (param?.action === 'download') {
      return result;
    }

    return commitList({ commit: context.commit }, SET_WPS_LIST, result);
  },

  async [CREATE_WPS](_, { api_namespace = 'wps', ...param }) {
    const { data } = await ApiService.post(`${resolveApiBase(api_namespace)}/requests`, param);
    return data;
  },

  async [UPDATE_WPS](_, { id, api_namespace = 'wps', ...payload }) {
    const { data } = await ApiService.put(`${resolveApiBase(api_namespace)}/requests/${id}`, payload);
    return data;
  },

  async [GET_DETAIL_WPS](context, { id, api_namespace = 'wps', query = {} }) {
    const { data } = await ApiService.get(`${resolveApiBase(api_namespace)}/requests/${id}/items`, query);
    const result = data?.data ?? data;

    if (query?.action === 'download') {
      return result;
    }

    return commitList({ commit: context.commit }, SET_DETAIL_LIST, result);
  },

  [APPROVE_WPS](_, { id, api_namespace = 'wps', ...body }) {
    return ApiService.patch(`${resolveApiBase(api_namespace)}/requests/${id}/approve`, body);
  },

  [REJECT_WPS](_, { id, api_namespace = 'wps', ...body }) {
    return ApiService.patch(`${resolveApiBase(api_namespace)}/requests/${id}/reject`, body);
  },

  [CANCEL_WPS](_, { id, api_namespace = 'wps', ...body }) {
    return ApiService.patch(`${resolveApiBase(api_namespace)}/requests/${id}/cancel`, body);
  },

  [APPROVE_DISBURSE_WPS](_, { id, api_namespace = 'wps', ...body }) {
    return ApiService.patch(`${resolveApiBase(api_namespace)}/requests/${id}/disburse/approve`, body);
  },

  [REJECT_DISBURSE_WPS](_, { id, api_namespace = 'wps', ...body }) {
    return ApiService.patch(`${resolveApiBase(api_namespace)}/requests/${id}/disburse/reject`, body);
  },

  [PROCESS_DISBURSE_WPS](_, { id, api_namespace = 'wps', ...body }) {
    return ApiService.patch(`${resolveApiBase(api_namespace)}/internals/${id}/disburse/process`, body);
  },

  [SUBMIT_APPROVAL_CRM_WPS](_, { id, api_namespace = 'wps', ...body }) {
    return ApiService.patch(`${resolveApiBase(api_namespace)}/internals/${id}/approve`, body);
  },

  [SUBMIT_REJECT_CRM_WPS](_, { id, api_namespace = 'wps', ...body }) {
    return ApiService.patch(`${resolveApiBase(api_namespace)}/internals/${id}/reject`, body);
  },

  [SUBMIT_APPROVAL_FINANCE_WPS](_, { id, api_namespace = 'wps', ...body }) {
    return ApiService.patch(`${resolveApiBase(api_namespace)}/internals/${id}/disburse/approve`, body);
  },

  [ADD_EMPLOYEE_TO_REQ_WPS](_, { id, api_namespace = 'wps', ...body }) {
    return ApiService.patch(`${resolveApiBase(api_namespace)}/requests/${id}/item`, body);
  },

  [UPDATE_REQ_EMPLOYEE_WPS](_, {
    id, item_id, api_namespace = 'wps', ...body
  }) {
    return ApiService.put(`${resolveApiBase(api_namespace)}/requests/${id}/item/${item_id}`, body);
  },

  [DELETE_REQ_WPS](_, {
    id, item_id, api_namespace = 'wps', ...body
  }) {
    return ApiService.delete(`${resolveApiBase(api_namespace)}/requests/${id}/item/${item_id}`, body);
  },

  [GET_REQ_BY_ID_WPS](context, { id, api_namespace = 'wps', ...param }) {
    return apiAction('get', `${resolveApiBase(api_namespace)}/requests/${id}/items`, param, {
      context,
      mutation: SET_REQ_BY_ID_WPS,
    });
  },

  // Invoice

  [WPS_INVOICE_LIST](context, { api_namespace = 'wps', ...param }) {
    return apiAction('get', `${resolveApiBase(api_namespace)}/invoices`, param, {
      context,
      mutation: SET_WPS_INVOICE,
    });
  },

  [WPS_INVOICE_LIST_PER_COMPANY](context, { companyId, api_namespace = 'wps', query }) {
    return apiAction('get', `${resolveApiBase(api_namespace)}/invoices/company/${companyId}`, query, {
      context,
      mutation: SET_WPS_INVOICE,
    });
  },

  [DETAIL_WPS_INVOICE_PER_ITEM](context, { id, api_namespace = 'wps', ...query }) {
    return apiAction('get', `${resolveApiBase(api_namespace)}/invoices/${id}/items`, query, {
      context,
      mutation: SET_DETAIL_WPS_INVOICE_PER_ITEM,
    });
  },

  [WPS_LOG](context, { id, api_namespace = 'wps', ...query }) {
    return apiAction('get', `${resolveApiBase(api_namespace)}/requests/${id}/logs`, query, {
      context,
      mutation: SET_WPS_LOG,
    });
  },
};

// Mutations

const listMutation = (stateKey, transform = (v) => v) => (state, data) => {
  try {
    state[stateKey] = {
      ...data,
      rows: data.count ? data.rows.map(transform) : [],
    };
  } catch (error) {
    console.error(`[mutation:${stateKey}]`, error);
  }
};

const mutations = {
  [SET_DETAIL_LIST]: listMutation('detail_list'),
  [SET_WPS_LIST]: listMutation('wps_list'),
  [SET_DETAIL_WPS]: listMutation('detail_wps'),
  [SET_REQ_BY_ID_WPS]: listMutation('req_by_id_wps'),
  [SET_WPS_INVOICE]: listMutation('wps_invoices'),
  [SET_DETAIL_WPS_INVOICE_PER_ITEM]: listMutation('detail_wps_invoices_per_item'),
  [SET_WPS_LOG]: listMutation('wps_log'),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
